import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../styles/pages.css";
import Banner from "../ui/Banner";
import golfback from "../../assets/images/golfback2.png";
import { getCategories } from "../../api";
import LandingImg from "../ui/LandingImg";
import page from "../../assets/images/page.png";
import page1 from "../../assets/images/page_1.png";
import page2 from "../../assets/images/page_2.png";
import page3 from "../../assets/images/page_3.png";
import page4 from "../../assets/images/page_4.png";
import page5 from "../../assets/images/page_5.png";
import page6 from "../../assets/images/page_6.png";
import page7 from "../../assets/images/page_7.png";
import page8 from "../../assets/images/page_8.png";
import page9 from "../../assets/images/page_9.png";
import page10 from "../../assets/images/page_10.png";
import page11 from "../../assets/images/page_11.png";
import page12 from "../../assets/images/page_12.png";
import page13 from "../../assets/images/page_13.png";
import page14 from "../../assets/images/page_14.png";
import page15 from "../../assets/images/page_15.png";
import page16 from "../../assets/images/page_16.png";

const Golf = () => {
  const navigate = useNavigate();
  // const { tab } = useParams();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryLoading, setCategoryLoading] = useState(true);
  const [error, setError] = useState(null);
  const pageImages = [
    page1, page2, page3, page4, page5, page6, page7, page8,
    page9, page10, page11, page12, page13, page14, page15, page16,
  ];

  // 카테고리 정보 가져오기
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setCategoryLoading(true);
        const categoriesData = await getCategories();
        setCategories(categoriesData.data.results);
        setCategoryLoading(false);
      } catch (err) {
        setError("Failed to load category information.");
        setCategoryLoading(false);
      }
    };

    fetchCategories();
  }, []);

  // 활성 탭 결정 (URL 파라미터 또는 첫 번째 카테고리)
  // const activeTab = tab || (categories.length > 0 ? categories[0].en_name.toLowerCase() : "");

  const handleTabChange = (tabId) => {
    if (tabId === 'golf') {
      navigate('/en/products/golf');
    }
    navigate(`/en/products/${tabId}`);
  };

  // 카테고리 로딩 중이면 로딩 표시
  if (categoryLoading) {
    return <div className="loading">loading</div>;
  }

  // 카테고리 데이터로 탭 구성
  const bannerConfig = {
    backgroundImage: golfback,
    title: "product descriptions",
    description: ["Innovation in Carbon-Aramid Composite Materials", "Ratel Park Golf Club"],
    tabs:[
      ...categories.map((category) => ({
        id: category.en_name.toLowerCase(),
        name: category.en_name,
      })),
      {
        id: "golf",
        name: "ratel park golf",
      },
    ],
  };

  // 카테고리 이름 매핑 생성
  const tabTitles = {};
  categories.forEach((category) => {
    tabTitles[category.en_name.toLowerCase()] = category.en_name;
  });

  const renderTabContent = () => {
    if (error) return <div className="error">{error}</div>;

    return (
      <div className="productarea-section">
        {loading && <div className="loading">loading</div>}
        {/* {pageImages.map((src, i) => (
          <LandingImg
            src={src}
            onLoad={() => setLoading(false)}
          />
        ))} */}
        <LandingImg
          src={page}
          onLoad={() => setLoading(false)}
        />
      </div>
    )
  };

  return (
    <div className="product-container">
      <Banner {...bannerConfig} activeTab={"golf"} onTabChange={handleTabChange} />
      {renderTabContent()}
    </div>
  );
};

export default Golf;
